import { CredentialType } from '@/api/types';
import { useSessionStore } from '@/store/session';

export type AllowedSignInMethods = {
  isEmailOTPAllowed: boolean;
  isVoiceOTPAllowed: boolean;
  isTextOTPAllowed: boolean;
  isPasswordAllowed: boolean;
  isCarrierPinAllowed: boolean;
  isGoogleSignInAllowed: boolean;
  isAppleSignInAllowed: boolean;

  isGoogleOnlySignIn: boolean;
  isSocialSignInAllowed: boolean;

  noSocialMethodCount: number;
};

export const useAllowedSignInMethods = () => {
  const allowedCredentials = useSessionStore((s) => s.allowedCredentials);

  const methods: AllowedSignInMethods = {
    isEmailOTPAllowed: false,
    isVoiceOTPAllowed: false,
    isTextOTPAllowed: false,
    isPasswordAllowed: false,
    isCarrierPinAllowed: false,
    isGoogleSignInAllowed: false,
    isAppleSignInAllowed: false,
    isGoogleOnlySignIn: false,
    isSocialSignInAllowed: false,
    noSocialMethodCount: 0,
  };

  allowedCredentials.forEach((credentialType) => {
    switch (credentialType) {
      case CredentialType.EMAIL_OTP:
        methods.isEmailOTPAllowed = true;
        methods.noSocialMethodCount++;
        break;
      case CredentialType.VOICE_OTP:
        methods.isVoiceOTPAllowed = true;
        methods.noSocialMethodCount++;
        break;
      case CredentialType.TEXT_OTP:
        methods.isTextOTPAllowed = true;
        methods.noSocialMethodCount++;
        break;
      case CredentialType.PASSWORD:
        methods.isPasswordAllowed = true;
        methods.noSocialMethodCount++;
        break;
      case CredentialType.CARRIER_PIN:
        methods.isCarrierPinAllowed = true;
        methods.noSocialMethodCount++;
        break;
      case CredentialType.SOCIAL_APPLE:
        methods.isAppleSignInAllowed = true;
        methods.isSocialSignInAllowed = true;
        break;
      case CredentialType.SOCIAL_GOOGLE:
        methods.isGoogleOnlySignIn = allowedCredentials.length === 1;
        methods.isGoogleSignInAllowed = true;
        methods.isSocialSignInAllowed = true;
    }
  });

  return methods;
};
